import moment from "moment";

export default (value) => {
  if (value) {
    return moment.utc(String(value)).format("L LT");
  }
  return "";
};
